import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { fmtDate } from "@/lib/api";
import { SectionTitle } from "@/components/common";
import { Loader2, ClipboardCheck, ArrowRight } from "lucide-react";

const STATO = {
  approvata: { label: "Checklist approvata", cls: "text-emerald-600 bg-emerald-400/10 border-emerald-400/30" },
  da_correggere: { label: "Da correggere", cls: "text-red-600 bg-red-500/10 border-red-400/30" },
  documenti_mancanti: { label: "Documenti mancanti", cls: "text-[#FFB020] bg-[#FFB020]/10 border-[#FFB020]/30" },
  in_verifica: { label: "In verifica", cls: "text-[#FC82ED] bg-[#FC82ED]/10 border-[#FC82ED]/30" },
};

export default function CodaChecklist() {
  const nav = useNavigate();
  const [items, setItems] = useState(null);

  useEffect(() => { api.get("/checklist-queue").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);

  return (
    <div className="fade-up" data-testid="coda-checklist-page">
      <SectionTitle sub="Incarichi in attesa di verifica documentale. Approva o rifiuta i documenti dalla scheda dell'incarico; all'approvazione di tutti gli obbligatori la pubblicazione si sblocca automaticamente.">Coda checklist</SectionTitle>

      {items === null ? (
        <div className="mt-8 flex justify-center"><Loader2 className="animate-spin text-[#FC82ED]" /></div>
      ) : items.length === 0 ? (
        <div className="card-immo p-12 text-center mt-6"><ClipboardCheck className="mx-auto text-[var(--muted)] mb-3" size={32} /><p className="text-sm text-[var(--muted)]">Nessun incarico in attesa di verifica.</p></div>
      ) : (
        <div className="mt-6 card-immo overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-left text-[11px] uppercase tracking-wide text-[var(--muted)] border-b border-[var(--border)]">
                  <th className="px-4 py-3">Immobile</th>
                  <th className="px-4 py-3">Agente</th>
                  <th className="px-4 py-3">Proprietario</th>
                  <th className="px-4 py-3 text-center">Doc. verificati</th>
                  <th className="px-4 py-3">Stato</th>
                  <th className="px-4 py-3">Ultima modifica</th>
                  <th className="px-4 py-3"></th>
                </tr>
              </thead>
              <tbody>
                {items.map((r) => {
                  const st = STATO[r.stato] || STATO.in_verifica;
                  return (
                    <tr key={r.id} data-testid={`queue-row-${r.id}`} className="border-b border-[var(--border)] last:border-0 hover:bg-slate-50/60 cursor-pointer"
                        onClick={() => nav(`/immobili/${r.id}?tab=documenti`)}>
                      <td className="px-4 py-3">
                        <div className="font-medium truncate max-w-[220px]">{r.titolo}</div>
                        {r.codice && <div className="text-[11px] text-[var(--muted)] mono">{r.codice}</div>}
                      </td>
                      <td className="px-4 py-3 text-slate-600">{r.agente || "—"}</td>
                      <td className="px-4 py-3 text-slate-600">{r.proprietario}</td>
                      <td className="px-4 py-3 text-center mono font-semibold">{r.doc_verificati}/{r.doc_totali}</td>
                      <td className="px-4 py-3">
                        <span data-testid={`queue-stato-${r.id}`} className={`inline-block text-[11px] font-semibold px-2 py-0.5 rounded-full border ${st.cls}`}>{st.label}</span>
                        {r.stato === "approvata" && r.approved_by && <div className="text-[10px] text-[var(--muted)] mt-1">da {r.approved_by} · {fmtDate(r.approved_at)}</div>}
                      </td>
                      <td className="px-4 py-3 text-slate-500 text-xs">{fmtDate(r.updated_at)}</td>
                      <td className="px-4 py-3 text-right"><ArrowRight size={15} className="text-[var(--muted)]" /></td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
